module.exports = __webpack_public_path__ + "img/enterprise.e3e8442.png";